// extracted by mini-css-extract-plugin
export default {"linha":"Estilos_linha__lwwsE","container":"Estilos_container__KB3Qs","titulo":"Estilos_titulo__qUkMc","imagemContainer":"Estilos_imagemContainer__VjrL3"};